import { observer } from 'mobx-react'
import React from 'react'
import { NavLink } from 'react-router-dom'
import ExternalLink from 'shared-components/ExternalLink'
import { Icon } from 'ui-framework'
import { linksHelp } from '../headerConfig'
import HeaderVM from '../HeaderVM'

export function MainHelp({ vm }: { vm: HeaderVM }) {
  const menuItems = linksHelp.map((item) => {
    return item.external ? (
      <ExternalLink
        key={item.link}
        href={item.link}
        className="btn btn--neutral btn--medium flex-row-center"
        onClick={item.onClick}>
        <Icon name={item.icon} size={25} className="margin-right-1" />
        <span>{item.title}</span>
      </ExternalLink>
    ) : (
      <NavLink
        key={item.link}
        to={item.link}
        className="btn btn--neutral btn--medium flex-row-center"
        onClick={vm.hideDialogs}>
        <Icon name={item.icon} size={25} className="margin-right-1" />
        <span>{item.title}</span>
      </NavLink>
    )
  })

  return (
    <div className="main-help txt-default">
      <div className="main-help__pic-wrapper" />
      <div className="padded-1">
        <h3 className="txt-subtitle margin-bottom-1">Need help?</h3>
        <div className="main-help__links">{menuItems}</div>
      </div>
    </div>
  )
}

export default observer(MainHelp)
